var React = require('react');

function Line (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fill{fill:#b3edbe;}")),React.createElement("path",{"className":"fill","d":"M247.4,1.1C239.1.2,230.2.4,221.7.3L195.8.1c-16.9-.1-34-.2-50.9.1C111.1.7,78.8,1.9,45.3,4.3,30.4,5.4,14.8,5.5.8,8.5c-1.4.4-.8,1.7.9,1.5C14.7,8.4,28.6,8.6,42,8.2c16.2-.5,32.3-1.6,48.5-2.4,33.6-1.6,67.2-1.7,100.9-1.2l28.4.5c9.5.1,19.4.5,28.8-.4C254.1,4.1,252.5,1.5,247.4,1.1Z","key":1})]);
}

Line.defaultProps = {"id":"line","viewBox":"0 0 252 10"};

module.exports = Line;

Line.default = Line;
